<app-flow-meter-report-toolbar
  [tractors]="tractors"
  [loadingVisible]="toolbarLoadingVisible"
  (load)="load($event)"
  (openDrawer)="openDrawer()"
  (export)="export()"
  [selectedTractors]="selectedItemKeys"
  [request]="request"></app-flow-meter-report-toolbar>
<dx-drawer
  [openedStateMode]="'overlap'"
  [revealMode]="'slide'"
  template="template"
  [(opened)]="isDrawerOpen"
  [height]="height"
  [closeOnOutsideClick]="true">
  <div *dxTemplate="let data of 'template'" style="width: 200px">
    <dx-list class="tractors-list"
             [dataSource]="tractors"
             [grouped]="true"
             [searchEnabled]="true"
             selectionMode="all"
             [(selectedItemKeys)]="selectedItemKeys"
             [(selectedItems)]="selectedItems"
             [showSelectionControls]="true"
             [searchExpr]="['domain_name', 'name']"
             [width]="350">
      <dxo-search-editor-options [height]="45" stylingMode="underlined">
        <dxi-button #btn
          name="flow-meter"
          location="after"
          [options]="searchBtnOptions"></dxi-button>
      </dxo-search-editor-options>
      <div *dxTemplate="let item of 'item'">
        {{ item.name }}
      </div>
    </dx-list>
  </div>

  <app-flow-meter-report [width]="width" [height]="height" [selected]="selectedItems" [loader]="flowMeterBatchDataLoader"></app-flow-meter-report>

</dx-drawer>
<dx-load-panel
  class="flow-meter-data-loading"
  shadingColor="rgba(0,0,0,0.2)"
  [(visible)]="isFlowMeterDataLoading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="false">

  <div *dxTemplate="let data of 'content'">{{flowMeterBatchDataLoader.loadedStr()}}</div>
</dx-load-panel>
